// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dcc7ae91","453":"68693753","455":"2cd3c311"}[chunkId] + ".chunk.js";
};